import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import { TJury } from "constants/architectsTranslation";
import useModal from "customHooks/useModal";
import { useState } from "react";

function JurySection({ jury }: { jury: TJury[] }) {
  const modal = useModal();
  const [selectedJury, setSelectedJury] = useState<TJury | null>(null);
  return (
    <div className="p-0 d-flex flex-column" style={{ listStyle: "none" }} id="">
      <h3>Jury</h3>
      <MolhamModalOffcanvas
        onHide={modal.handleCloseModal}
        fullscreen
        show={modal.showModal}
        header={{
          label: selectedJury?.name,
        }}
      >
        <div className="pb-3 fw-bold" style={{ color: "var(--dark-gray)" }}>
          {selectedJury?.title}
        </div>
        <div className="p-0">{selectedJury?.desc}</div>
      </MolhamModalOffcanvas>
      {jury.map((text, index) => (
        <a
          onClick={() => {
            setSelectedJury(text);
            modal.handleShowModal();
          }}
          className="ps-3 fs-18 dark-gray text-decoration-none cursor"
          key={index}
        >
          {text.name}
        </a>
      ))}
    </div>
  );
}

export default JurySection;
